import { type FC } from 'react'
import { Status } from 'shared/ui'
import type { IStatusProps } from 'shared/ui/Status'
import styles from './styles.module.scss'

type IEstimatedResponseInfoProps = {
  iconData: IStatusProps | null
}

export const EstimatedResponseInfo: FC<IEstimatedResponseInfoProps> = ({ iconData }) => {
  if (!iconData || !iconData.title) return null

  return (
    <div className={styles.statusLine}>
      <Status
        emphasis='high'
        intent={iconData.intent}
        title={iconData.title}
        icon={iconData.icon}
      />
    </div>
  )
}
